import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { SelectPage } from 'src/app/team-members/select/select.page';
import { BillingRatesPage } from 'src/app/time-and-billing/billing-rates/billing-rates.page';

@Component({
  selector: 'app-billing-groups-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {

 billing_groups: any = [];
   billing_rates: any = [];
   @Input() show_paging = true;
   @Input() hideColumns: string[] = [];

   @ViewChild('dt') billingGroupsTable: Table;
   activeBillingGroupFilterLabels: string[] = [];
   private readonly billingGroupFilterLabelMap: { [field: string]: string } = {
     title: 'Title',
     code: 'Code',
   };

   onBillingGroupTableFilter(event: any) {
     this.activeBillingGroupFilterLabels = this.computeActiveFilterLabels(event.filters, this.billingGroupFilterLabelMap);
   }

   clearBillingGroupFilters() {
     if (this.billingGroupsTable) this.clearTableFilters(this.billingGroupsTable);
     this.activeBillingGroupFilterLabels = [];
   }

   private clearTableFilters(t: Table): void {
     if (!t) return;
     (t as any).tableService.onResetChange();
     if ((t as any).isStateful()) (t as any).clearState();
     (t as any)._filter();
   }

   private computeActiveFilterLabels(filters: any, labelMap: { [field: string]: string }): string[] {
     if (!filters) return [];
     const active: string[] = [];
     for (const field of Object.keys(labelMap)) {
       const raw = filters[field];
       if (!raw) continue;
       const constraints = Array.isArray(raw) ? raw : [raw];
       const hasValue = constraints.some((c: any) => {
         if (c.value === null || c.value === undefined) return false;
         if (Array.isArray(c.value)) return c.value.length > 0;
         if (typeof c.value === 'string') return c.value.trim().length > 0;
         return true;
       });
       if (hasValue) active.push(labelMap[field]);
     }
     return active;
   }
 
   constructor(private apiService: ApiService, public modalController: ModalController, public globalService: GlobalService) { }
 
  ngOnInit() {
    this.GetData();
  }

  async GetData() {
    await this.GetBillingRates();
    await this.GetBillingGroups();
  }

  async GetBillingRates() {
    let data: any = await this.apiService.get('billing/rates');
    if (data.success) {
      this.billing_rates = data.data;
    } 
  }
  async GetBillingGroups() {
    let data: any = await this.apiService.get('billing_groups');
    if (data.success) {
      console.log("BG: ", data);
      this.billing_groups = data.data;
      if(this.billing_groups == null) this.billing_groups = [];
      this.billing_groups.forEach(element => {
        if(!element.team_members) element.team_members = [];
        else{
          element.team_members.forEach(team_member => {
            team_member.rate = this.billing_rates[this.globalService.GetArrayIndex(this.billing_rates,team_member.rate_guid)];
            console.log(team_member.rate);
            console.log("TEAM MEMBER: " + team_member.display_name);
            
          });
        }
      });
    } 
  }

 

  async Create() {
    
  }

  async Update() {
    
  }

  async ManageMembers(billing_group) {
    let billing_group_members_company = JSON.stringify(billing_group.team_members);
    console.log(billing_group.team_members);
    const modal = await this.modalController.create({
      component: SelectPage,
      cssClass: 'large-modal tall-modal',
      componentProps: {
        selected_team_members: billing_group.team_members,
        remove_team_members: billing_group.team_members,
        selecting_for_billing: true,
        modal_title: 'Assigning Team Member Rates to ' + billing_group.title
      }
    })
    modal.onDidDismiss().then((data: any) => {
      console.log(data.data);
      if (data.data) {
        billing_group_members_company = JSON.parse(billing_group_members_company);
        this.CheckGroupTeamMembers(billing_group,billing_group_members_company, data.data);

        console.log(data.data);
      }
      else {
        billing_group.team_members = [...JSON.parse(billing_group_members_company)];
      }
    });
    return await modal.present()
  }

  async Delete(billing_group) {
    let data: any = await this.apiService.delete(`billing_groups/${billing_group.guid}}`,null);
    this.globalService.RemoveFromArray(this.billing_groups,billing_group.guid);
  }

  async AddMember(billing_group,member) {
    console.log("Add: " + member.display_name);
    this.apiService.post(`billing_groups/members/${billing_group.guid}`,member);
  }

  async RemoveMember(billing_group,member) {
    this.apiService.delete(`billing_groups/members/${billing_group.guid}`,member);
    this.globalService.RemoveFromArray(billing_group,member.guid);
  }

  async UpdateTeamMember(billing_group,team_member) {
    console.log("Update Billing Group Member: " + team_member);
    let data: any = await this.apiService.put(`billing_groups/members/${billing_group.guid}`, team_member);
  }


  async CheckGroupTeamMembers(billing_group,old_group_members, new_group_members) {
    //Check to see if all the old team_members still exist, if not we will run a delete statement to the api
    old_group_members.forEach(team_member => {
      const index = new_group_members.findIndex(e => team_member.guid === e.guid);
      if (index == -1) {
        this.RemoveMember(billing_group,team_member);
      }
    });
    //If the old client does not exist in the new team_members, run api statement to add it
    new_group_members.forEach(team_member => {
      const index = old_group_members.findIndex(e => team_member.guid === e.guid);
      if (index == -1) {
        this.AddMember(billing_group,team_member);
      }
    });

    new_group_members.forEach(team_member => {
      const index = old_group_members.findIndex(e => team_member.guid === e.guid);
      if (index >= 0) {
        if (JSON.stringify(team_member) != JSON.stringify(old_group_members[index])) {
          this.UpdateTeamMember(billing_group,team_member);
        }
      }
    });
  }


  async ManageBillingRates() {
    const modal = await this.modalController.create({
      component: BillingRatesPage,
      cssClass: 'large-modal tall-modal',
      componentProps: {

      }
    })
    modal.onDidDismiss().then((data: any) => {
      this.GetData();
    });
    return await modal.present()
  }

  async ManageBillingCategories() {

  }

  async presentInactiveConfirmTaxRate(billing_group) {

  }

  async Edit(billing_group) {
    
  }





}
